import { render, staticRenderFns } from "./step_budget.vue?vue&type=template&id=7f24cb4a&scoped=true"
import script from "./step_budget.vue?vue&type=script&lang=js"
export * from "./step_budget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f24cb4a",
  null
  
)

export default component.exports